import React, { useState } from "react";
import Box from "ReusableComponents/Box";
import Add from "assets/Add.svg";
import Close from "assets/close.svg";
import Text from "ReusableComponents/Text";
import { COLORS, WEIGHT } from "theme";
import RightPath from "assets/rightPath.svg";
import RightPathWhite from "assets/rightpathWhite.png";
import Button from "ReusableComponents/Button";

const VehicleBox = ({
  name,
  noVehicle,
  img,
  isBooking,
  getSelectedVehicle,
  small,
  sku_name,
  alt,
}) => {
  const [hover, setHover] = useState(false);

  const boxWidth = small ? "100%" : "300px";
  const boxHeight = small ? "130px" : "219px";
  const boxPadding = small ? "18px" : "24px";
  const textFontSize = small ? "14px" : "22px";
  const buttonWidth = small ? "100%" : "140px";
  const buttonMargin = small ? "20px 0" : "26px";
  const textButtonFontSize = small ? "12px" : "16px";

  return (
    <Box
      position="relative"
      w={boxWidth}
      margin="0 auto"
      style={{ maxWidth: "300px" }} // Ensure max-width on larger screens
    >
      <Box
        h={boxHeight}
        b={`1px solid ${noVehicle ? "#707070" : "#707070"}`}
        margin="0 auto"
        borderRadius="6px"
        padding={boxPadding}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        style={{
          width: boxWidth,
          transition: "width 0.3s ease",
        }}
      >
        {!noVehicle && (
          <>
            <img
              src={Close}
              alt="close"
              style={{
                top: -15,
                display: "none",
                right: -10,
                position: "absolute",
                cursor: "pointer",
              }}
            />
          </>
        )}

        <img
          src={noVehicle ? Add : img}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          alt={alt}
          onClick={() =>
            isBooking && getSelectedVehicle({ name, img, sku_name })
          }
          style={{
            maxHeight: "100%",
            maxWeight: "100%",
            cursor: "pointer",
            transform: hover && `scale(1.2)`,
            transition: "all 0.3s ease-in-out",
          }}
        />
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        color="white"
        textAlign={isBooking ? "left" : "center"}
      >
        <Text
          textColor={COLORS.white}
          fontSize={textFontSize}
          fontWeight={WEIGHT.bold}
        >
          {name}
        </Text>
      </Box>
      {isBooking && (
        <Button
          display="flex"
          w={buttonWidth}
          margin={buttonMargin}
          alignItems="center"
          justifyContent="center"
          cursor="pointer"
          hoverBackground={true}
          background={hover ? COLORS.black : COLORS.primary}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          onClick={() => getSelectedVehicle({ name, img, sku_name })}
          style={{
            transition: "background 0.3s ease",
          }}
        >
          <Text
            fontSize={textButtonFontSize}
            fontWeight="bold"
            textColor={hover ? COLORS.white : COLORS.black}
          >
            Book now
          </Text>
          <img
            src={hover ? RightPathWhite : RightPath}
            alt="rightPath"
            style={{ margin: "0 8px" }}
            height="16px"
          />
        </Button>
      )}
    </Box>
  );
};

export default VehicleBox;
